import { render } from "./AdminSysUsersTab.vue?vue&type=template&id=0cba79b2&ts=true"
import script from "./AdminSysUsersTab.vue?vue&type=script&lang=ts"
export * from "./AdminSysUsersTab.vue?vue&type=script&lang=ts"

import "./AdminSysUsersTab.vue?vue&type=style&index=0&id=0cba79b2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__